import { Form, InputGroup, Button } from "react-bootstrap";


interface SearchInputProps {
    searchText: string;
    onChange: (value: string) => void;
    onSearch: () => void;
    onClear?: () => void;
    placeholder?: string;
}
const Search: React.FC<SearchInputProps> = ({ searchText, onChange, onSearch, onClear, placeholder }) => { 
    return (
        <div style={{ marginTop: 0, marginBottom: 0 }}>
            <InputGroup className="md">
            <Form.Control
                type="text"
                placeholder={placeholder}
                value={searchText}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault(); // evita que se env�e un formulario si est� dentro de uno
                            onSearch(); // tu funci�n a ejecutar
                        }
                    }}
            />
            {searchText && (<button
                type="button"
                className="btn btn-sm btn-clear-input"
                onClick={() => {
                    onClear();
                }}
                style={{
                    position: "absolute",
                    right: "60px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    border: "none",
                    padding: 0,
                }}
            >
                <i className="bi bi-x"></i>
            </button>
            )}
            <Button variant="secondary" onClick={onSearch}>
                <i className="bi bi-search"></i>
            </Button>
            </InputGroup>
        </div>
    )
}


export default Search;